// @flow
import React from 'react'
import { Row, Col } from 'react-flexbox-grid'

import '../styles.css'

const nameValidate = value => (
  /^[a-zA-Z\s]*$/.test(value)
)

const emptyNameValidate = (i, referrals) => (
  !referrals[i].name && referrals[i].email
)

const emailValidate = value => (
  /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value) ||
  value === ''
)

const emptyEmailValidate = (i, referrals) => (
  referrals[i].name && !referrals[i].email
)

const nameInput = (i, referrals, onChange) => {
  const value = referrals[i].name
  const validate = nameValidate(value)
  const isEmpty = emptyNameValidate(i, referrals)
  const color = {
    color: value === '' ? '#9696ae'
      : !validate ? '#FF7585' : '#474759'
  }
  return (
    <Col
      xs={12} sm={5} md={5} lg={5}
      className='label'
      style={color}
    >
      Nombre
      <input
        className='input'
        type='text'
        value={value}
        onChange={(event) => onChange(event, i, 'name')}
        style={color}
      />
      <Row className='input-error-message'>
        {validate ? '' : 'Sólo podés escribir letras y espacios.'}
        {isEmpty ? 'Escribí el nombre de esta persona.' : ''}
      </Row>
    </Col>
  )
}

const emailInput = (i, referrals, onChange) => {
  const value = referrals[i].email
  const validate = emailValidate(value)
  const isEmpty = emptyEmailValidate(i, referrals)
  const color = {
    color: value === '' ? '#9696ae'
      : !validate ? '#FF7585' : '#474759'
  }
  return (
    <Col
      smOffset={1}
      xs={12} sm={5} md={5} lg={5}
      className='label'
      style={color}
    >
      E-mail
      <input
        className='input'
        type='text'
        value={value}
        onChange={(event) => onChange(event, i, 'email')}
        style={color}
      />
      <Row className='input-error-message'>
        {validate ? '' : 'Formato de correo inválido'}
        {isEmpty ? ' Escribí el e-mail de esta persona.' : ''}
      </Row>
    </Col>
  )
}

const renderInputs = (i, referrals, onChange) => (
  <Row
    center='xs'
    className='input-container'
    key={i}
  >
    {nameInput(i, referrals, onChange)}
    {emailInput(i, referrals, onChange)}
  </Row>
)

const ReferralForm = props => {
  const {
    onChange,
    onSubmit,
    onAddInputs,
    referrals
  } = props
  return (
    <form onSubmit={onSubmit}>
      {referrals.map((item, i) => (
        renderInputs(i, referrals, onChange)
      ))}
      <Row center='xs'>
        <Col className='info-message' xs={12} sm={10} md={10} lg={10}>
          Enviaremos un correo a tu nombre para invitar
          a las personas que indicastes a probar Wink.
        </Col>
      </Row>
      <Row center='xs'>
        <input
          className='submit-btn'
          style={{
            marginTop: 10
          }}
          type='submit'
          value='ENTENDIDO, ENVIAR INVITACIONES'
        />
      </Row>
    </form>
  )
}

export default ReferralForm



// WEBPACK FOOTER //
// ./src/pages/Referral/components/form.js